import posthog from "posthog-js";
import { POSTHOG_API_KEY } from "@/constants";

export default {
  install(Vue) {
    const apiKey = POSTHOG_API_KEY();
    if (!apiKey) {
      return;
    }

    const isStaging = window.location.host.includes("optixdev.com");

    posthog.init(apiKey, {
      api_host: "https://us.i.posthog.com",
      disable_session_recording: true,
      session_recording: {
        recordCrossOriginIframes: true,
      },
      persistence: "cookie",
      autocapture: !isStaging,
      capture_pageleave: false,
    });

    Vue.prototype.$posthog = posthog;
  },
};
